import { Switch } from "@/components/ui/switch";
import type { CustomerMemoryControlProps } from "@/types/voice/customer-memory";

export const CustomerMemoryControl = ({
  status,
  isUpdating = false,
  onChange,
  compact = false,
}: CustomerMemoryControlProps) => (
  <div className={compact ? "flex items-center justify-between gap-4" : "rounded-2xl border border-[#E9EDF3] bg-white p-4"}>
    <div className="min-w-0 pr-3">
      <p className="text-[14px] font-semibold text-[#222B45]">Remember me next time</p>
      <p className="mt-0.5 text-[12px] leading-snug text-[#64748B]">
        Save useful details for 90 days. Turn this off anytime to forget them.
      </p>
    </div>
    <Switch
      checked={status === "granted"}
      disabled={isUpdating}
      onCheckedChange={onChange}
      aria-label="Remember useful details for future conversations"
    />
  </div>
);
